import React, { useState } from 'react';

import { Badge, PopoverBody, Tag, TagLabel } from '@chakra-ui/react';

import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';

import { Button, Divider, Flex, Icon, Link, Stack } from '@brand/components';
import IInterventionSearched from 'models/InterventionSearched';

import pages from 'constants/pages';

import ComponentIsVisible from 'components/utils/IsVisible';

interface Props {
  interventionSearchList: IInterventionSearched[];
}

const SearchPopOverContent = ({ interventionSearchList }: Props) => {
  const [firstIndex, setFirstIndex] = useState(0);
  const [secondIndex, setSecondIndex] = useState(5);

  const handleShowNext = () => {
    setFirstIndex(prevFirstIndex => prevFirstIndex + 5);
    setSecondIndex(prevSecondIndex => prevSecondIndex + 5);
  };
  const handleShowPrev = () => {
    setFirstIndex(prevFirstIndex => prevFirstIndex - 5);
    setSecondIndex(prevSecondIndex => prevSecondIndex - 5);
  };

  return (
    <PopoverBody>
      <Stack spacing={2}>
        {interventionSearchList
          .slice(firstIndex, secondIndex)
          .map(
            ({
              address,
              case_id,
              id,
              user_email,
              user_first_name,
              user_last_name,
              user_phone,
            }) => (
              <Link
                href={id ? pages.intervention.details(id) : '/'}
                key={id}
                style={{ textDecoration: 'none' }}
              >
                <Flex
                  align="center"
                  bg="gray.100"
                  borderRadius="xl"
                  direction="column"
                  justify="space-between"
                  p={4}
                  sx={{
                    _hover: {
                      backgroundColor: 'gray.200',
                    },
                  }}
                >
                  {/* Top Block */}
                  <Flex
                    align="center"
                    justify="center"
                    width={[`340px`, `370px`, `430px`]}
                  >
                    <Tag
                      backgroundColor="red.300"
                      borderRadius="0.5rem 0 0 0"
                      borderTopLeftRadius="lg"
                      size="lg"
                      w="50%"
                    >
                      <Flex align="center" justify="center">
                        <Badge
                          backgroundColor="white"
                          border="1.7px solid white"
                          borderRadius="0.5rem 0 0.5rem 0"
                          color="secondary"
                          m={1}
                          variant="outline"
                        >
                          Id
                        </Badge>
                        <TagLabel color="white">{id}</TagLabel>
                      </Flex>
                    </Tag>
                    <Tag
                      backgroundColor="lightBlue"
                      borderRadius="0 0.5rem 0rem 0"
                      size="lg"
                      w="50%"
                    >
                      <Badge
                        backgroundColor="white"
                        border="1.7px solid white"
                        borderRadius="full"
                        color="secondary"
                        m={1}
                        variant="outline"
                      >
                        Case Id
                      </Badge>
                      <TagLabel color="white">{case_id}</TagLabel>
                    </Tag>
                  </Flex>
                  {/* Center top block */}
                  <Divider orientation="horizontal" />
                  <Flex align="flex-start" width={[`340px`, `370px`, `430px`]}>
                    <Tag
                      backgroundColor="heading"
                      borderRadius="0 0 0 0.5rem"
                      size="lg"
                      w="50%"
                    >
                      <TagLabel color="white">{user_first_name}</TagLabel>
                    </Tag>
                    <Divider orientation="vertical" />
                    <Tag
                      backgroundColor="heading"
                      borderRadius="0 0 0.5rem 0"
                      size="lg"
                      w="50%"
                    >
                      <TagLabel color="white">{user_last_name}</TagLabel>
                    </Tag>
                  </Flex>
                  {/* Center bottom block */}
                  <Divider orientation="horizontal" />
                  <Flex align="flex-start" width={[`340px`, `370px`, `430px`]}>
                    <Tag
                      backgroundColor="headingDarker"
                      borderRadius="0 0 0 0.5rem"
                      size="lg"
                      w="60%"
                    >
                      <TagLabel color="white">{user_email}</TagLabel>
                    </Tag>
                    <Divider orientation="vertical" />
                    <Tag
                      backgroundColor="headingDarker"
                      borderRadius="0 0 0.5rem 0"
                      size="lg"
                      w="40%"
                    >
                      <TagLabel color="white">{user_phone}</TagLabel>
                    </Tag>
                  </Flex>
                  {/* Bottom block */}
                  <Divider orientation="horizontal" />
                  <Flex align="flex-start" width={[`340px`, `370px`, `430px`]}>
                    <Tag
                      backgroundColor="heading"
                      borderRadius="0 0 0.5rem 0.5rem"
                      size="lg"
                      w="100%"
                    >
                      <TagLabel color="white">{address}</TagLabel>
                    </Tag>
                    <Divider orientation="vertical" />
                  </Flex>
                </Flex>
              </Link>
            ),
          )}
        <ComponentIsVisible when={interventionSearchList.length > 5}>
          <Flex justify="space-around">
            <ComponentIsVisible when={firstIndex > 0}>
              <Button
                leftIcon={<Icon as={AiOutlineArrowLeft} h={5} width={5} />}
                onClick={handleShowPrev}
                variant="outlineBlue"
              >
                Show Prev 5
              </Button>
            </ComponentIsVisible>
            <Button
              onClick={handleShowNext}
              rightIcon={<Icon as={AiOutlineArrowRight} h={5} width={5} />}
              variant="lightBlue"
            >
              Show Next 5
            </Button>
          </Flex>
        </ComponentIsVisible>
      </Stack>
    </PopoverBody>
  );
};

export default SearchPopOverContent;
